import Model from '~/models/Model';

export default class EmailTemplate extends Model {
  resource() {
    return 'v1/email-templates';
  }
}
